import { render, staticRenderFns } from "./LocationHistoryItem.vue?vue&type=template&id=50f0c7f6&scoped=true&"
import script from "./LocationHistoryItem.vue?vue&type=script&lang=js&"
export * from "./LocationHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./LocationHistoryItem.vue?vue&type=style&index=0&id=50f0c7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0c7f6",
  null
  
)

export default component.exports